import { useState } from "react";
import { useHistory } from "react-router-dom";
import useTranslations from "../../../core/i18n/useTranslations";
import { useSaveObject } from "../../../core/SaveObjectContext/hooks";
import Button from "../../../ui-lib/components/Button/Button";
import { PopupContextMenuLinkButton } from "../../../ui-lib/components/Menus/PopupContextMenu/PopupContextMenuLinkButton";
import { DeleteAlarmReceptionModal } from "../DeleteAlarmReceptionModal";
import useUser from "../../../core/user/useUser";
import { PopupMenu } from "../../../ui-lib/components/Menus/PopupMenu";
import { Spacer } from "../../../components/Layout/Layout";

const AlarmReceptionActions = ({
  responseCenterId,
  parentPath,
}: {
  responseCenterId?: number;
  parentPath: string;
}) => {
  const t = useTranslations();
  const history = useHistory();
  const { canSave, isDirty, isSaving, onSave } = useSaveObject();
  const { config } = useUser();

  const [deleteAlarmReceptionModalOpen, setDeleteAlarmReceptionModalOpen] =
    useState(false);

  return (
    <>
      {canSave && (
        <Button
          text={t("Common:save")}
          disabled={!isDirty}
          loading={isSaving}
          onClick={onSave}
        />
      )}
      {config?.show.includes("RcDelete") && (
        <>
          <Spacer size={8} />
          <PopupMenu variant="secondary" buttonText={t("Common:other")}>
            <PopupContextMenuLinkButton
              icon="trash"
              text={t("AlarmReceptions:delete")}
              onClick={() => setDeleteAlarmReceptionModalOpen(true)}
            />
          </PopupMenu>
        </>
      )}
      <DeleteAlarmReceptionModal
        isOpen={deleteAlarmReceptionModalOpen}
        responseCenterId={responseCenterId}
        onClose={() => setDeleteAlarmReceptionModalOpen(false)}
        onDelete={() => history.replace(parentPath)}
      />
    </>
  );
};

export default AlarmReceptionActions;
